/* eslint no-console:0 */
/*
 * this file is automatically compiled by Webpack, along with any other files
 * present in this directory. You're encouraged to place your actual application logic in
 * a relevant structure within app/javascript and only use these pack files to reference
 * that code so it'll be compiled.
 *
 * To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
 * layout file, like app/views/layouts/application.html.erb
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createSagaMiddleware from "redux-saga";
import { setupAxios } from "@services/setupAxios";
import axios from "axios";
import createReduxStore from './store';
import Routes from './routes';
import cleverTap from './services/cleverTap';
import "../css/tailwind-output.css";
import "./tailwind.css";
import { ActionCableProvider } from 'react-actioncable-provider'
import '@assets/stylesheets/application.scss';
import { rootSaga } from '@store/rootDuck';
import { Helmet } from 'react-helmet';

cleverTap.initialize();

// when path for websocket is '/cable', we can skip url prop.
class Application extends React.Component {

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.log(error);
        cleverTap.event('ERROR_OCCURED', {
            Error: error.message,
            Stack: error.stacktrace
        });
    }

    render() {
        return <>
            <Helmet>
                <meta name="description" content="PayU Partner Portal" />
                <title>Partner Portal</title>
                <link rel="canonical" href="https://partner.payu.in/app/dashboard" />
            </Helmet>
            <ActionCableProvider>
                <Routes />
            </ActionCableProvider>
        </>
    }
}

const sagaMiddleware = createSagaMiddleware();
const store = createReduxStore({}, sagaMiddleware);

sagaMiddleware.run(rootSaga);

/* mock api calls */
// mockAxios(axios);

setupAxios(axios, store);

ReactDOM.render(
    <Provider store={store}>
        <Application />
    </Provider>,
    document.getElementById('app')
);
